import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "直播", to: "/live", icon: "ri-live-line" },
  { label: "赛程", to: "/schedule", icon: "ri-calendar-line" },
  { label: "新闻", to: "/news", icon: "ri-newspaper-line" },
  { label: "关于", to: "/about", icon: "ri-information-line" },
];

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) => {
    if (to === "/news") return location.pathname.startsWith("/news");
    if (to === "/live") return location.pathname === "/live";
    return location.pathname === to;
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-primary-950 border-b border-primary-800">
      <div className="w-full px-4 md:px-6 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 shrink-0 cursor-pointer">
          <span className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center text-accent-950 text-2xl">
            <i className="ri-basketball-line"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl md:text-2xl font-bold tracking-wide text-background-50">
              NBA<span className="text-accent-400">直播吧</span>
            </span>
            <span className="hidden sm:block text-[10px] tracking-[0.25em] text-primary-300 mt-0.5">
              LIVE · SCHEDULE · NEWS
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive(item.to)
                  ? "bg-primary-800 text-background-50"
                  : "text-primary-200 hover:text-background-50 hover:bg-primary-900"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden lg:flex items-center gap-2 text-xs font-label text-primary-200 bg-primary-900 px-3 py-1.5 rounded-full">
            <i className="ri-live-line text-accent-400"></i> 今日 3 场直播
          </span>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-background-50 text-2xl cursor-pointer hover:bg-primary-900"
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden bg-primary-950 border-t border-primary-800 px-4 py-3 flex flex-col gap-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium cursor-pointer ${
                isActive(item.to)
                  ? "bg-primary-800 text-background-50"
                  : "text-primary-200 hover:bg-primary-900"
              }`}
            >
              <i className={`${item.icon} text-lg`}></i>
              {item.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}